// assets
import { IconSettings, IconGitBranch, IconPlayerPlay, IconCalendar, IconChartBar, IconServer } from '@tabler/icons-react';

// constant
const icons = { IconSettings, IconGitBranch, IconPlayerPlay, IconCalendar, IconChartBar, IconServer };

// ==============================|| LUỒNG CÔNG VIỆC (Airflow) – theo project từ Workspace ||============================== //

const workflow = {
    id: 'workflow',
    title: 'Luồng công việc',
    type: 'group',
    children: [
        {
            id: 'workflow-module',
            title: 'Workflow',
            type: 'collapse',
            icon: icons.IconGitBranch,
            children: [
                {
                    id: 'workflow-dashboard',
                    title: 'Dashboard',
                    type: 'item',
                    url: '/workflow/dashboard',
                    breadcrumbs: false
                },
                {
                    id: 'dags',
                    title: 'DAGs',
                    type: 'item',
                    url: '/workflow/dags',
                    breadcrumbs: false
                },
                {
                    id: 'task-runs',
                    title: 'Task Runs',
                    type: 'item',
                    url: '/workflow/runs',
                    breadcrumbs: false
                },
                {
                    id: 'scheduler',
                    title: 'Scheduler',
                    type: 'item',
                    url: '/workflow/scheduler',
                    breadcrumbs: false
                },
                {
                    id: 'workflow-analytics',
                    title: 'Analytics',
                    type: 'item',
                    url: '/workflow/analytics',
                    breadcrumbs: false
                },
                {
                    id: 'workflow-servers',
                    title: 'Servers',
                    type: 'item',
                    url: '/workflow/servers',
                    breadcrumbs: false
                }
            ]
        }
    ]
};

export default workflow;
